"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework class for EnumControl controls
         */
        var EnumControl = /** @class */ (function (_super) {
            __extends(EnumControl, _super);
            function EnumControl() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            EnumControl.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                if (!this.Items) {
                    this.Items = $dyn.observableArray([]);
                }
                if (!$dyn.isObservable(this.SelectedItem)) {
                    // SelectedItem contains the currently selected value (not the index)
                    this.SelectedItem = $dyn.observable(this.SelectedItem);
                }
                this.shownItem = $dyn.observable($dyn.value(this.SelectedItem));
                this.selectedIndex = $dyn.computed(this.getSelectedIndex, function (newValue) {
                    _this.setSelectedIndex(newValue);
                }, this);
                this.shownIndex = $dyn.computed(function () {
                    var selected = $dyn.value(_this.shownItem);
                    return _this.getItemIndex(selected);
                }, function (index) {
                    if (_this.allowUserChanges()) {
                        var items = $dyn.value(_this.Items);
                        if (items.length > index && items[index]) {
                            _this.shownItem(items[index].Value);
                        }
                    }
                });
                this.isValueEmpty = $dyn.computed(function () {
                    return (_this.selectedLabel() === "") ? true : false;
                });
                this.Value = this.formattedValue = $dyn.computed(function () { return _this.selectedLabel(); });
                $dyn.observe(this.SelectedItem, function (newValue) {
                    if (newValue !== $dyn.value(_this.shownItem)) {
                        // If messages weren't cleared in setSelectedIndex, do it here
                        _this.removeMessages();
                        _this.shownItem(newValue);
                        if ($dyn.value(_this.Required)) {
                            // Mandatory met condition could have changed
                            _this.UpdateStatusArea();
                        }
                    }
                });
                this.skipCollapsedSelection = $dyn.computed(function () { return _this.isInGrid(); });
                if (!this.isInactiveCell()) {
                    $dyn.observe(this.IsValid, function (newValue) {
                        if (_this.Root && _this.Root.UpdateInvalidControlList) {
                            _this.Root.UpdateInvalidControlList(_this);
                        }
                        if (newValue && $dyn.value(_this.shownItem) !== $dyn.value(_this.SelectedItem)) {
                            _this.removeMessages();
                            _this.shownItem($dyn.value(_this.SelectedItem));
                        }
                        _this.UpdateStatusArea();
                    });
                }
                var clientState = $dyn.value(this.ClientState);
                if (clientState && typeof (clientState) === "string") {
                    // We will only parse clientState if it's a string
                    if (this.applyClientState) {
                        var clientStateAsObj_1 = JSON.parse(clientState);
                        // Something was set on the server as client-only state.
                        // Do an async call to process this value.
                        $dyn.async(function () {
                            _this.applyClientState(clientStateAsObj_1);
                        });
                    }
                }
            };
            /**
             * Update the selectedIndex and call setValue
             * @param newIndex What to set the selectedIndex to
             * @param forceChange Whether to update the property even if it hasn't changed
             * @param forceCommandCall Whether or not to call SetSelectedItem even if the control is not editable
             * @returns A promise that gets resolved when the value setting process is completed
             */
            EnumControl.prototype.setSelectedIndex = function (newIndex, forceChange, forceCommandCall) {
                if (forceChange === void 0) { forceChange = false; }
                if (forceCommandCall === void 0) { forceCommandCall = false; }
                var result;
                if (forceCommandCall || this.allowUserChanges()) {
                    var items = $dyn.value(this.Items);
                    if (items.length > newIndex && newIndex >= 0) {
                        this.removeMessages();
                        if (this.ValueChanged) {
                            $dyn.callFunction(this.ValueChanged, this, newIndex);
                        }
                        this.shownItem(items[newIndex].Value);
                        result = this.setValue($dyn.value(this.shownItem), forceChange, forceCommandCall);
                        if ($dyn.value(this.Required)) {
                            // Mandatory met condition could have changed
                            this.UpdateStatusArea();
                        }
                    }
                }
                if (!result) {
                    result = $.Deferred();
                    result.resolve();
                }
                return result;
            };
            /**
             * Gets the index of the SelectedItem
             * @returns The index of the SelectedItem
             */
            EnumControl.prototype.getSelectedIndex = function () {
                var selected = $dyn.value(this.SelectedItem);
                return this.getItemIndex(selected);
            };
            EnumControl.prototype.isMandatoryMet = function () {
                var met = true;
                var label = this.selectedLabel();
                if (($dyn.value(this.shownItem) === 0 || $dyn.value(this.shownItem) === "0") && (label === undefined || label === "")) {
                    met = false;
                }
                return met;
            };
            /**
             * Gets the label from the shown item
             * @returns The selected label
             */
            EnumControl.prototype.selectedLabel = function () {
                var items = $dyn.value(this.Items);
                if (items) {
                    var selectedValue = $dyn.value(this.shownItem);
                    var item = items[this.getItemIndex(selectedValue)];
                    if (item) {
                        return item.Label;
                    }
                    else {
                        return "";
                    }
                }
            };
            /**
             * Update the SelectedItem
             * @param newValue The new value to set the SelectedItem to
             * @param forceChange Whether to update the property even if it hasn't changed
             * @param forceCommandCall Whether or not to call SetValue even if the control is not editable
             * @returns A promise that gets resolved when the value setting process is completed
             */
            EnumControl.prototype.setValue = function (newValue, forceChange, forceCommandCall) {
                var _this = this;
                if (forceChange === void 0) { forceChange = false; }
                if (forceCommandCall === void 0) { forceCommandCall = false; }
                var result = $.Deferred();
                // tslint:disable-next-line:triple-equals
                if ((forceCommandCall || this.allowUserChanges()) && (forceChange || newValue != $dyn.value(this.SelectedItem) || !$dyn.value(this.IsValid))) {
                    if (this.SetSelectedItem) {
                        var commandCallback_1 = function (success) {
                            if (success || $dyn.value(_this.IsValid)) {
                                if ($dyn.value(_this.shownItem) !== $dyn.value(_this.SelectedItem)) {
                                    _this.shownItem($dyn.value(_this.SelectedItem));
                                }
                            }
                            result.resolve();
                        };
                        var failureCallback = function () {
                            commandCallback_1(true); // true will force a sync of the value
                        };
                        $dyn.callFunction(this.SetSelectedItem, this, [newValue], commandCallback_1, null /*complete*/, null /*before*/, null /*throttle*/, failureCallback);
                    }
                    else {
                        $dyn.setValue(this, "SelectedItem", newValue, forceChange);
                        this.IsValid(true);
                    }
                }
                else {
                    result.resolve();
                }
                return result;
            };
            EnumControl.prototype.ApplyState = function (clientState) {
                var _this = this;
                var retVal;
                if (clientState.messages && clientState.messages.length > 0) {
                    this.messages = clientState.messages;
                }
                if (clientState.shownItem !== undefined) {
                    // Update the formatted value if it's different from the one stored in the Client State on the server
                    if (clientState.shownItem !== $dyn.value(this.shownItem())) {
                        var shownIndex = this.getItemIndex(clientState.shownItem);
                        var result = this.setSelectedIndex(shownIndex, true, true);
                        retVal = $.Deferred();
                        result.done(function () {
                            if ($dyn.value(_this.IsValid)) {
                                retVal.resolve();
                            }
                            else {
                                retVal.reject();
                            }
                        });
                        return result;
                    }
                }
            };
            EnumControl.prototype.GetState = function () {
                return {
                    shownItem: $dyn.value(this.shownItem)
                };
            };
            EnumControl.prototype.onSerializeTransitState = function () {
                // Send our shownIndex to the server so that it can be deserialized later.
                var clientState = JSON.stringify({
                    shownIndex: this.shownIndex()
                });
                // Set ClientState
                $dyn.setValue(this, "ClientState", clientState);
            };
            EnumControl.prototype.displayedValue = function () {
                return this.selectedLabel();
            };
            EnumControl.prototype.displayedValues = function (onlyIncludeDirtyValues) {
                var displayedValues = {};
                if (!onlyIncludeDirtyValues) {
                    displayedValues[this.Name] = this.displayedValue();
                }
                return displayedValues;
            };
            EnumControl.prototype.attached = function () {
                var _this = this;
                _super.prototype.attached.call(this);
                this.shownItem = $dyn.observable($dyn.value(this.SelectedItem));
                this.selectedIndex = $dyn.computed(this.getSelectedIndex, function (newValue) {
                    _this.setSelectedIndex(newValue);
                }, this);
            };
            /**
             * Gets the label from the specified index
             * @param virtualIndex The index to get the label for
             * @returns The label for that index
             */
            EnumControl.prototype.getItemLabelByIndex = function (virtualIndex) {
                var items = $dyn.value(this.Items);
                if (items) {
                    var item = items[this.getItemIndex(virtualIndex)];
                    if (item) {
                        return item.Label;
                    }
                }
            };
            /**
             * Gets the index of the Item with the matching value
             * @param value The value to match
             * @returns The index of the first matching item, -1 if not found
             */
            EnumControl.prototype.getItemIndex = function (value) {
                var items = $dyn.value(this.Items);
                if (items) {
                    for (var i = 0, len = items.length; i < len; i++) {
                        var item = items[i];
                        // tslint:disable-next-line:triple-equals
                        if (item.Value == value) {
                            return i;
                        }
                    }
                }
                return -1;
            };
            EnumControl.prototype.applyClientState = function (clientState) {
                if (clientState.shownIndex !== undefined) {
                    // Update the formatted value if it's different from the one stored in the Client State on the server
                    if (clientState.shownIndex !== this.shownIndex()) {
                        this.shownIndex(clientState.shownIndex);
                    }
                }
            };
            return EnumControl;
        }(controls.Edit));
        controls.EnumControl = EnumControl;
        EnumControl.prototype.ComboType = $dyn.ui.autoValue;
        EnumControl.prototype.SelectedItem = 0;
        EnumControl.prototype.Items = null;
        EnumControl.prototype.SetSelectedItem = null;
        EnumControl.prototype.SupportsDefaultAction = false;
        EnumControl.prototype.recordability = $dyn.util.recordabilityDefault;
        $dyn.adapter({ id: "ListBox", controlType: "EnumControl", template: "ListBox" });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=EnumControl.js.map
